<template>
  <div id="modal-calc-email" class="modal modal_callback" style="display: none;">
    <div v-if="isThanks" class="modal__inner">
      <div class="h2 m-b-s">
        Готово!
      </div>
      <p>
        Список товаров для оформления отправлен вам на почту.
      </p>
    </div>
    <div v-else class="modal__inner">
      <div class="h2 m-b-s">
        Отправить список покупок на E-mail
      </div>
      <p>
        Укажите ваш e-mail, чтобы отправить на него список выбранных товаров.
      </p>
      <form class="form" @submit.prevent="submit" style="width: 451px;">
        <div class="field">
          <label class="field__label">E-mail</label>
          <div class="inp-wrap has-success">
            <input class="inp" :class="{valid: isEmailValid, error: !isEmailValid}" type="text" v-model="email">
            <span v-if="!isEmailValid" class="help-block form-error">* поле e-mail обязательно к заполнению</span>
          </div>
        </div>
        <div class="field">
          <label class="checkbox-wrap">
            <input type="checkbox" class="checkbox" v-model="checkrules">
            <span class="checkbox-imitator"></span>
            Ознакомлен с <a href="/legal/policy/" target="_blank" class="link-nb">правилами обработки персональных данных</a>
            <span v-if="!isCheckrulesValid" class="help-block form-error">Необходимо принять правила обработки персональных данных</span>
          </label>
        </div>
        <div class="field">
          <button type="submit" class="btn"><span>Отправить</span></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      pdfData: String,
    },
    data() {
      return {
        email: '',
        checkrules: false,
        isEmailValid: true,
        isCheckrulesValid: true,
        isThanks: false,
      };
    },
    methods: {
      validate() {
        this.isEmailValid = /.+@.+\..+/.test(this.email);
        this.isCheckrulesValid = this.checkrules;

        return (this.isEmailValid && this.isCheckrulesValid);
      },
      submit() {
        if (this.validate()) {
          const data = 'email=' + encodeURIComponent(this.email) + '&data=' + encodeURIComponent(this.pdfData);

          const xhr = new XMLHttpRequest();
          xhr.open('POST', process.env.VUE_APP_SEND_URL);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.onload = () => {
            this.isThanks = true;
          };
          xhr.send(data);
        }
      },
    },
  };
</script>

<style scoped>
  .inp.error {
    border-color: rgb(185, 74, 72);
  }
</style>